import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadTrackingGraphComponent } from './load-tracking-graph.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from '../tooltip/tooltip.module';
import { TimezoneModule } from '../timezone/timezone.module';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  declarations: [LoadTrackingGraphComponent],
  imports: [
    CommonModule,
    MatExpansionModule,
    TranslateModule.forChild({}),
    TooltipModule,
    TimezoneModule,
    SvgIconModule,
  ],
  exports: [LoadTrackingGraphComponent],
})
export class LoadTrackingGraphModule {}
